import React from "react";
import { View } from "react-native";
import { DrawerContext } from "../../drawer-provider";
import CreateButton from "./create-button";
import StepsHeader from "./create-document-steps";
import SearchHeader from "./search-header";
import useStyles from "./styles.css";
import TitleSection from "./title-section";

const IgnoreSearchBar = ["My Account", "Advance Settings", "Advance Settings ", "Face Recognition","Upgrade Plan", "Create Document", "Affix Document", "Payment Success", "Payment Failed", "Delete"];
const IgnoreSearchBarSecond = ["signature-upload"];

const WebHeader = () => {
  const styles = useStyles();
  const { steps, activeTab, activeSecondScreen } = React.useContext(DrawerContext);

  return (
    <View style={styles.v_header_items}>
      <TitleSection />
      {activeTab === "Create Document" && steps === "Sign" && <StepsHeader />}
      {activeTab === "Create Document" && steps === "Send" && <StepsHeader />}
      {activeTab === "Create Document" && steps === "Send-Sign" && <StepsHeader />}
      {IgnoreSearchBar.includes(activeTab) || activeTab.includes("SafeForm Lite -") || IgnoreSearchBarSecond.includes(activeSecondScreen) ? 
        null :
        <>
          <SearchHeader />
          <CreateButton />
        </> }
    </View>
  );
};

export default WebHeader;
